import React, { useState, useEffect } from "react";
import { apiFetch } from "../lib/api";
import { Wrench } from "lucide-react";

export default function EquipmentAssets() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("/equipment-assets");
      if (res?.ok) setItems(res.items || []);
    } catch {
      // Fallback
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  return (
    <div className="space-y-4" id="equipment-assets-page" data-testid="equipment-assets-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-[#082B4D] flex items-center gap-2">
            <Wrench className="w-5 h-5 text-[#18B84F]" />
            Equipment & Certification Register (Asset & Operator Gatekeeping)
          </h1>
          <p className="text-xs text-slate-500">Asset tags, inspection bodies, certificate expiries, quarantine status & PTW blocking</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden text-xs">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200 text-slate-600 font-semibold uppercase text-[10px]">
            <tr>
              <th className="p-3">Asset Code</th>
              <th className="p-3">Equipment Name</th>
              <th className="p-3">Type</th>
              <th className="p-3">Status</th>
              <th className="p-3">Next Inspection Due</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 font-mono">
            {loading ? (
              <tr><td colSpan="5" className="p-4 text-center text-slate-400">Loading equipment assets...</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan="5" className="p-4 text-center text-slate-400">No equipment asset records found.</td></tr>
            ) : (
              items.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50">
                  <td className="p-3 font-bold text-blue-600">{r.equipment_code || r.asset_tag}</td>
                  <td className="p-3 font-sans font-medium text-slate-800">{r.name}</td>
                  <td className="p-3 uppercase text-[10px]">{r.equipment_type}</td>
                  <td className="p-3"><span className={`px-2 py-0.5 rounded text-[9px] font-bold uppercase ${r.status === 'in_service' ? 'bg-emerald-100 text-emerald-800' : 'bg-rose-100 text-rose-800'}`}>{r.status}</span></td>
                  <td className="p-3 text-slate-500">{r.next_inspection_due || "N/A"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
